import { defaultPersonCensorColumns } from "../../../../../config/person";
import {
  createColumnEditorTrigger,
  getHeaderActiveColumns,
  TD,
} from "../../../../../util/table";
import { tableToXLSX } from "../../../../../util/tableExportUtils";
import ButtonDownload from "../../../../ButtonDownload";
import { ModalProvider } from "../../../../Modal/Modal";
import {
  TableBody,
  TableHead,
  TableRoot,
  TableRow,
} from "../../../../Table/TableBasic";
import ColumnEditorModal from "@/components/column-editor/ColumnEditorModal";
import IngenRegistreringer from "../IngenRegistreringer";
import { PersonDto } from "../../../../../interfaces/schema";
import { SortBy } from "../../../../../interfaces/table";
import useLocalStorageState from "use-local-storage-state";
import useActiveColumns from "../../../../../hooks/useActiveColumns";
import { RetssagsProeveField } from "../../../../../interfaces/personer";
import { orderBy } from "../../../../../util/orderBy";

export default function Censor({ person }: { person: PersonDto }) {
  const { fmuretssagsproeveCensor } = person;
  const [activeColumns, setActiveColumns] = useActiveColumns(
    "person-censor-active-columns",
    defaultPersonCensorColumns,
  );
  const [sortBy, setSortBy] = useLocalStorageState<SortBy[]>(
    "personCensorSortBy",
    {
      defaultValue: defaultSortBy,
    },
  );

  function downloadHandler() {
    tableToXLSX(activeColumns, [], {
      fileName: `censor-for-${person.kundeNr}`,
      additionalData: {
        kundenr: person.kundeNr,
      },
    });
  }

  if (!fmuretssagsproeveCensor?.length) {
    return <IngenRegistreringer />;
  }

  return (
    <>
      <ButtonDownload onClick={downloadHandler} />
      <ModalProvider>
        <TableRoot>
          <TableHead ColumnEditorTrigger={createColumnEditorTrigger()}>
            {getHeaderActiveColumns(activeColumns, {
              defaultSortBy,
              setSortBy,
              sortBy,
            })}
          </TableHead>
          <TableBody>
            {orderBy(
              fmuretssagsproeveCensor,
              sortBy.map((s) => s.field),
              sortBy.map((s) => s.direction),
            ).map((censor, i) => {
              return (
                <TableRow key={i}>
                  <>
                    {activeColumns
                      .filter((col) => col.active)
                      .map((col) => {
                        return (
                          <TD key={col.field} col={col} rowData={censor} />
                        );
                      })}
                  </>
                </TableRow>
              );
            })}
          </TableBody>
        </TableRoot>
        <ColumnEditorModal
          defaultColumns={defaultPersonCensorColumns}
          columns={activeColumns}
          setActiveColumns={setActiveColumns}
        />
      </ModalProvider>
    </>
  );
}

const defaultSortBy: SortBy<RetssagsProeveField>[] = [
  {
    direction: "desc",
    field: "proceduredato",
  },
];
